// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"nine-block-grid_gridContainer__Qdqws","grid":"nine-block-grid_grid__1tiwn"};